import React, { useState } from "react";
import { api, V1 } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { CreditCard, Loader2, Tag, Check, X } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

export default function PurchaseButton({ kind, code, cycle = "monthly", price, label, variant = "default", size = "default", testId }) {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [couponOpen, setCouponOpen] = useState(false);
  const [coupon, setCoupon] = useState("");
  const [applied, setApplied] = useState(null); // {code, discount, final_amount}

  const checkCoupon = async () => {
    if (!coupon.trim()) return;
    try {
      const { data } = await api.post(`${V1}/coupons/check`, { code: coupon.trim(), kind, item_code: code, amount: price });
      setApplied(data);
      toast.success(`Kupon uygulandı: -₺${data.discount}`);
    } catch (e) { toast.error(e?.response?.data?.detail || "Geçersiz kupon"); }
  };

  const clearCoupon = () => { setApplied(null); setCoupon(""); };

  const startCheckout = async () => {
    if (!user) {
      window.location.href = `/giris?next=${encodeURIComponent(window.location.pathname)}`;
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post(`${V1}/payments/iyzico/checkout-form/init`, {
        kind, code, cycle, coupon_code: applied?.code || null,
      });
      window.location.href = data.payment_page_url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Ödeme başlatılamadı");
    } finally { setBusy(false); }
  };

  const displayPrice = applied ? applied.final_amount : price;

  return (
    <div className="space-y-1.5">
      <Button onClick={startCheckout} disabled={busy} variant={variant} size={size} data-testid={testId || `buy-${kind}-${code}`} className="w-full">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <CreditCard className="h-4 w-4" />}
        {label || (displayPrice != null ? `₺${displayPrice} · Satın Al` : "Satın Al")}
        {applied && <span className="ml-1 text-[10px] line-through opacity-70">₺{price}</span>}
      </Button>
      {!couponOpen && !applied && (
        <button type="button" onClick={() => setCouponOpen(true)} className="text-[10px] text-muted-foreground hover:text-primary flex items-center gap-1" data-testid={`show-coupon-${code}`}>
          <Tag className="h-3 w-3" /> Kupon kodum var
        </button>
      )}
      {couponOpen && !applied && (
        <div className="flex gap-1" data-testid={`coupon-row-${code}`}>
          <Input className="h-7 text-xs" value={coupon} onChange={(e) => setCoupon(e.target.value.toUpperCase())} placeholder="KUPON" data-testid={`coupon-input-${code}`} />
          <Button size="sm" variant="outline" onClick={checkCoupon} className="h-7 text-xs px-2" data-testid={`coupon-apply-${code}`}><Check className="h-3 w-3" /></Button>
        </div>
      )}
      {applied && (
        <div className="flex items-center gap-1 text-[10px] text-success" data-testid={`coupon-applied-${code}`}>
          <Check className="h-3 w-3" /> {applied.code} · -₺{applied.discount}
          <button onClick={clearCoupon}><X className="h-3 w-3 text-muted-foreground" /></button>
        </div>
      )}
    </div>
  );
}
